import React from 'react';

const Pulse: React.FC<{ className?: string }> = ({ className = '' }) => (
  <div className={`bg-[var(--bg-tertiary)] rounded-lg animate-pulse ${className}`} />
);

const SkeletonLoading: React.FC = () => {
  return (
    <div className="max-w-xl mx-auto px-5 pt-5">
      {/* Animated logo */}
      <div className="flex flex-col items-center py-6">
        <div className="w-16 h-16 bg-[var(--accent-10)] rounded-2xl flex items-center justify-center mb-3 animate-pulse">
          <div className="w-8 h-8 bg-[var(--accent-20)] rounded-xl"></div>
        </div>
        <div className="h-4 w-28 bg-[var(--bg-tertiary)] rounded animate-pulse"></div>
      </div>

      {/* Header skeleton */}
      <div className="flex items-center gap-3 mb-6">
        <Pulse className="w-11 h-11 rounded-2xl" />
        <div className="flex-1">
          <Pulse className="h-5 w-36 mb-2" />
          <Pulse className="h-3 w-48" />
        </div>
      </div>

      {/* Search skeleton */}
      <Pulse className="h-12 w-full rounded-full mb-6" />

      {/* Category header skeleton */}
      <Pulse className="h-11 w-full rounded-xl mb-4" />

      {/* Card grid skeleton */}
      <div className="grid grid-cols-2 gap-3">
        {[...Array(6)].map((_, i) => (
          <div key={i} className="bg-[var(--bg-card)] rounded-2xl overflow-hidden border border-[var(--glass-border)]">
            <Pulse className="w-full h-36 rounded-none" />
            <div className="p-3">
              <Pulse className="h-4 w-3/4 mb-2" />
              <Pulse className="h-3 w-full mb-1" />
              <Pulse className="h-3 w-2/3 mb-3" />
              <div className="flex justify-between items-center">
                <Pulse className="h-5 w-16" />
                <Pulse className="w-10 h-10 rounded-2xl" />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Second category skeleton */}
      <Pulse className="h-11 w-full rounded-xl mt-8 mb-4" />
      <div className="grid grid-cols-2 gap-3">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="bg-[var(--bg-card)] rounded-2xl overflow-hidden border border-[var(--glass-border)]">
            <Pulse className="w-full h-36 rounded-none" />
            <div className="p-3">
              <Pulse className="h-4 w-3/4 mb-2" />
              <Pulse className="h-3 w-full mb-1" />
              <Pulse className="h-3 w-1/2 mb-3" />
              <div className="flex justify-between items-center">
                <Pulse className="h-5 w-16" />
                <Pulse className="w-10 h-10 rounded-2xl" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SkeletonLoading;
